import React from "react";
import { SingleDropdownListWithoutSearchBoot } from "../../../Common/Components/SingleDropdownListWithoutSearchBoot";
import { Form } from "react-bootstrap";

interface ReportVersionSelectProps {
  reportVersionList: any[]; 
  selectedVersion: string;
  onVersionChange: (selectedVersion: string, selectedVersionId: string) => void; 
}

const CustomerVersion: React.FC<ReportVersionSelectProps> = ({ 
  reportVersionList, 
  selectedVersion, 
  onVersionChange 
}) => {
  
  const handleSelectedItem = (control: string, id: string) => {
    if (control === "Version") {
      const selectedVersionObj = reportVersionList.find(x => x.id === id);
      if (selectedVersionObj) {
        onVersionChange(selectedVersionObj.name, selectedVersionObj.id);
      }
    }
  };

  return (
    <Form.Group controlId="reportversion" style={{ marginTop: "20px" }}>
      <Form.Label className="font-semibold">Customer Version</Form.Label>
      <div style={{ width: "100%" }}>
        <SingleDropdownListWithoutSearchBoot
          itemList={reportVersionList}
          handleSelectedItem={(id: string) => handleSelectedItem("Version", id)}
          defaultItem={selectedVersion}
          defaultText="Select Filter"
          defaultName={selectedVersion}
          controlID="1"
          id="ddlselected"
        />
      </div>
    </Form.Group>
  );
};

export default CustomerVersion;
